import type { Components, Theme } from "@mui/material";

export const tooltipTheme: Components<Theme>["MuiTooltip"] = {
  styleOverrides: {
    tooltip: ({ theme }) => ({
      ...theme.typography.caption,
      background: theme.palette.grey[900],
      color: theme.palette.primary.contrastText,
      padding: `${theme.spacing(1)} ${theme.spacing(1.5)}`,
      borderRadius: theme.borderRadius.xs,
      boxShadow: `0px 2px 8px 0px ${theme.palette.grey[500]}`,
    }),
    arrow: ({ theme }) => ({
      color: theme.palette.grey[900],
    }),
  },
};
